// Hooks
import useToastsNotifications from '@/utils/hooks/swr/notifications/useToastsNotifications';

// Components
import NotificationsCounter from '@/components/base/NotificationsCounter';

export function MenuNotification() {
    const { unreadNotifications, hasUnreadNotifications } = useToastsNotifications({
        revalidateIfStale: false
    });
    if (!hasUnreadNotifications) {
        return null;
    }

    return (
        <NotificationsCounter className="absolute -right-2.5 -top-2 flex items-center justify-center">
            {unreadNotifications > 20 ? '20+' : unreadNotifications}
        </NotificationsCounter>
    );
}
